// extracted by mini-css-extract-plugin
export default {"containerError":"styles_containerError__JPGYO","containerImage":"styles_containerImage__02PxD"};